exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ic_view {\n    display: inline-block;\n    min-width: 17px;\n    height: 17px;\n    margin-top: 2px;\n    border: 1px solid #fff;\n    border-radius: 50px;\n    background: #fff;\n    color: black;\n    font-size: 11px;\n    margin-right: 5px;\n    padding: 0 3px 0 2px;\n}\n\n.div_status{\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 100%;\n\n}\n\n.status-pending{\n    background-color:red;\n}\n\n.status-approved{\n    background-color:green;\n}\n\n.status-paid{\n    background-color:blue;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/list-requisition/list-requisition.component.css
// module id = ../../../../../src/app/list-requisition/list-requisition.component.css
// module chunks = main